/** 研修一覧の絞り込み条件。「すべて」(all) や未入力は API に送らない（API は厳密な enum のため） */
export function buildTrainingFilters(input: {
  search: string
  trainingType: string
  category: string
}): Record<string, string | undefined> {
  return {
    search: input.search || undefined,
    trainingType:
      input.trainingType && input.trainingType !== 'all' ? input.trainingType : undefined,
    category: input.category || undefined,
  }
}

/** 残席が 0 のとき満席（定員無制限は満席にならない）。残席自体は API の remainingSeats を使う */
export function isSoldOut(remainingSeats: number | null | undefined): boolean {
  return remainingSeats === 0
}
